import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { DEFAULT_CONTENT } from "../lib/defaultContent";
import SmoothScroll from "../components/site/SmoothScroll";
import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import Ticker from "../components/site/Marquee";
import About from "../components/site/About";
import Services from "../components/site/Services";
import Manifesto from "../components/site/Manifesto";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import FloatingContact from "../components/site/FloatingContact";

export default function Home() {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    api.get("/content").then(({ data }) => data && setContent(data)).catch(() => {});
    api.post("/track", { path: "/", referrer: document.referrer || "" }).catch(() => {});
  }, []);

  return (
    <SmoothScroll>
      <Nav brand={content.brand} />
      <main>
        <Hero hero={content.hero} stats={content.stats} logo={content.brand?.logoUrl} />
        <Ticker text={content.marqueeText} />
        <About about={content.about} />
        <Services services={content.services} />
        <Manifesto manifesto={content.manifesto} />
        <Contact contact={content.contact} services={content.services} />
      </main>
      <Footer brand={content.brand} footer={content.footer} contact={content.contact} />
      <FloatingContact contact={content.contact} />
    </SmoothScroll>
  );
}
